module.exports = __webpack_public_path__ + "img/03-B02.4e2cf8f0.png";